import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=138de5dc&"
import script from "./Resources.vue?vue&type=script&lang=ts&"
export * from "./Resources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports